import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ToHomeBtn from "../components/Shared/ToHomepageBtn";
import "./css/DeleteAccountPage.css";

const DeleteAccountPage = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [isDeleting, setIsDeleting] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleDeleteAccount = async () => {
        if (!user) {
            toast.error("Ingen användare inloggad");
            return;
        }

        setIsDeleting(true);
        try {
            // delete all user data from the users table
            const { error: userError } = await supabase
                .from("users")
                .delete()
                .eq("id", user.id);

            if (userError) throw userError;

            // Sign out the user
            await supabase.auth.signOut();

            toast.success("Ditt konto har tagits bort");
            navigate("/");
        } catch (error) {
            console.error("Error deleting account:", error);
            toast.error("Ett fel uppstod vid borttagning av kontot");
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className="delete-account-page">
            <ToastContainer />
            <ToHomeBtn />
            <div className="delete-account-container">
                <h1>Ta bort konto</h1>
                <p>Är du säker på att du vill ta bort ditt konto?</p>
                <p>Denna kan inte ångras.</p>
                <p>All din data kommer att raderas permanent från vår databas.</p>

                <div className="button-container">
                    <button
                        className="confirm-delete-button"
                        onClick={() => setShowConfirmation(true)}
                        disabled={isDeleting}
                    >
                        {isDeleting ? "Tar bort..." : "Ja, ta bort mitt konto"}
                    </button>
                    <button
                        className="cancel-button"
                        onClick={() => navigate("/login-and-account")}
                        disabled={isDeleting}
                    >
                        Avbryt
                    </button>
                </div>
            </div>

            {showConfirmation && (
                <div className="confirmation-overlay">
                    <div className="confirmation-dialog">
                        <p>Like bro you sure? your data will all be gone you sure?</p>
                        <div className="confirmation-buttons">
                            <button
                                className="confirm-delete-button"
                                onClick={handleDeleteAccount}
                                disabled={isDeleting}
                            >
                                {isDeleting ? "Tar bort..." : "Ye"}
                            </button>
                            <button
                                className="cancel-button"
                                onClick={() => setShowConfirmation(false)}
                                disabled={isDeleting}
                            >
                                Nah
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DeleteAccountPage; 